import { render, staticRenderFns } from "./kioskDemoView.vue?vue&type=template&id=4db4ef50&scoped=true"
import script from "./kioskDemoView.vue?vue&type=script&lang=js"
export * from "./kioskDemoView.vue?vue&type=script&lang=js"
import style0 from "./kioskDemoView.vue?vue&type=style&index=0&id=4db4ef50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4ef50",
  null
  
)

export default component.exports